import { FC, PropsWithChildren } from 'react';

import './SidebarWrapper.scss';

interface SidebarWrapperProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Sidebar that sits alongside the page content on the right edge.
 * When open, the main content area shifts to make room (handled via Root.tsx).
 * Always rendered in the DOM so CSS transitions can animate open/close.
 */
const SidebarWrapper: FC<PropsWithChildren<SidebarWrapperProps>> = ({ open, children }) => {
  return (
    <div className="nostra__sidebarWrapper" data-open={open}>
      <div className="nostra__sidebarWrapper__content">{children}</div>
    </div>
  );
};
export default SidebarWrapper;
